import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Localization } from '../../app/app.localization';
import { Storage } from '@ionic/storage';
import { OrderComponent } from '../../components/order/order';
import { Broadcaster } from '../../app/broadcaster';
import { Config } from '../../app/app.config';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage';

/**
 * Generated class for the MenulistPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-menulist',
  templateUrl: 'menulist.html',
})
export class MenulistPage {

  @ViewChild("order") order: OrderComponent;
  @ViewChild("scrollBox") scrollBox: ElementRef;

  iTotal: number = 0;
  menus: Array<any>;
  categories: Array<any>;
  currentItemId: Number;
  foodsMenu: Array<any>;
  foodsSubMenu: Array<any>;
  indexes: any;
  containerTopMargin: String = "0px";
  backgroundStyle: {};
  styleAttritube: String = "";
  backgroundImage: String = "";
  orderList = [];
  chargeId: any;
  subArray = [];

  constructor(
    public navCtrl: NavController,
    private _loc: Localization,
    private broadcaster: Broadcaster,
    private _okageStorage: OkageStorageProvider,
    public storage: Storage,
    public navParams: NavParams
  ){
    localStorage.setItem("orderList", JSON.stringify(""));
    this.init();
    let storeConfig = JSON.parse(localStorage.getItem("configs"));
    if (storeConfig["MOBILEORDER_FIXED_LAYOUT_BACKGROUND_IMAGE"] && storeConfig["MOBILEORDER_FIXED_LAYOUT_BACKGROUND_IMAGE"].length > 0){
      this.backgroundImage = storeConfig["MOBILEORDER_FIXED_LAYOUT_BACKGROUND_IMAGE"];
      this.backgroundStyle = {'background-image': `url(${this.backgroundImage})`};
    }
    if (storeConfig["MOBILEORDER_FIXED_LAYOUT_BACKGROUND_COLOR"] && storeConfig["MOBILEORDER_FIXED_LAYOUT_BACKGROUND_COLOR"].length > 0) {
      this.backgroundStyle = {'background-color': storeConfig["MOBILEORDER_FIXED_LAYOUT_BACKGROUND_COLOR"]};
    }
  }

  // ionViewDidLoad() {
  //   console.log('ionViewDidLoad MenulistPage');
  // }

  /**
   * ViewEnter
   */
  ionViewWillEnter(){
    this.orderList = JSON.parse(localStorage.getItem('orderList')) ? JSON.parse(localStorage.getItem('orderList')) : [];
    this.updateCartItemNum();
    this.hideOrder();

    let isReturnHistory = localStorage.getItem('returnHistory') === '1' ? true : false;
    if (isReturnHistory) {
      let orderHistory = JSON.parse(localStorage.getItem('orderHistory'));
      this.currentItemId = orderHistory.id;
    }
    localStorage.setItem('returnHistory', '0');
  }

  /**
   * async 初期化
   */
  async init() {
    this.indexes = [
    ];
    this.currentItemId = 0;
    this.orderList = JSON.parse(localStorage.getItem('orderList')) ? JSON.parse(localStorage.getItem('orderList')) : [];
    this.subArray = JSON.parse(this._okageStorage.getItem('foods.submenu'));
    this.foodsMenu = await this.storage.get('foods.menu');
    this.updateCartItemNum();
    this.broadcaster.on<number>('foodCounterChanged').subscribe(this.updateCartItemNum.bind(this));
    this.chargeId = localStorage.getItem("chargeId");
    var lockImageUri = Config.service + "?r=menus/soldoutimage&client_cd=" + localStorage.getItem("client_cd") + "&store_id=" + localStorage.getItem("store_id") +"&";
    var menus = [];
    var categories = [];
    for (let c of this.foodsMenu){
      for (let m of c){
        if (m["parent"]) continue;  // 子メニューはスキップ

        if (!categories[m.category_id]){
          categories[m.category_id] = {
            category_id: m.category_id,
            category_name: m.category_name,
            category_sort_order: m.category_sort_order,
            menus: []
          };
        }
        var menuLockImageUri = (m.is_rock == "1") ? lockImageUri+"is_rock" : (m.is_soldout_rock == "1") ? lockImageUri+"is_soldout_rock" : (m.is_wait_arrival_rock == "1") ? lockImageUri+"is_wait_arrival_rock" : "";
        let objMenu = {
          menuId: m.id,
          menuName: m.title,
          especialPrice: parseInt(m.price, 0),
          excludeTaxPrice: parseInt(m.notax_price, 0),
          formattedPrice: this.changeFormattedPrice(m),
          menuImageUri: m.thumb,
          originObject: m,
          menuSortOrder: m.menu_sort_order,
          menuLockImageUri : menuLockImageUri
        };

        menus.push(objMenu);
        categories[m.category_id]["menus"].push(objMenu);
      }
    }
    var sortedCategories = [];
    for (let c of categories){
      if (c){
        c.menus.sort((a, b) => {
          if (parseInt(a.menuSortOrder, 0) < parseInt(b.menuSortOrder, 0)) return -1;
          if (parseInt(a.menuSortOrder, 0) > parseInt(b.menuSortOrder, 0)) return 1;
        })
        sortedCategories.push(c);
      }
    }
    this.menus = menus;
    this.categories = sortedCategories;
    this.categories.sort((a, b) => {
      if (parseInt(a.category_sort_order, 0) < parseInt(b.category_sort_order, 0)) return -1;
      if (parseInt(a.category_sort_order, 0) > parseInt(b.category_sort_order, 0)) return 1;
      return 0;
    });
    this.categories.forEach((c, i) => {
      this.indexes.push({
        title: c.category_name,
        id: c.category_id,
        onTap: this.selectCategoryIndex.bind(this)
      });
    });
  }
  /**
   * 表示する金額を設定
   */
  changeFormattedPrice(menu){
    var formattedPrice = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(menu.price);
    // サブメニューが存在する場合
    if (this.subArray[menu.id]) {
      var requiredSubMenu = this.subArray[menu.id].filter(subMenu => subMenu.required); // 必須のみ取得
      if (requiredSubMenu.length > 0) { // 必須のサブメニューがある場合
        var subMenuGroupTotalPrice = 0; // サブグループごとの最安値を集計
        let subMenuGroupId = ""; // サブグループ判定
        // 2重forで対応. iがgroup判定、jがグループ内の最安値判定
        for (let i = 0; i < requiredSubMenu.length; i++) {
          if (subMenuGroupId != requiredSubMenu[i].group_id) {
            let subMenuGroupMinPrice = parseInt(requiredSubMenu[i].price); // group内の最安値保存
            subMenuGroupId = requiredSubMenu[i].group_id;
            for (let j = i+1; j < requiredSubMenu.length; j++) {
              if (subMenuGroupId == requiredSubMenu[j].group_id && subMenuGroupMinPrice >= parseInt(requiredSubMenu[j].price)) {
                subMenuGroupMinPrice = parseInt(requiredSubMenu[j].price); // group内の最安値より金額が安い場合、入れ替える
              }
            }
            subMenuGroupTotalPrice += subMenuGroupMinPrice; // group内の最安値をサブグループごとの最安値を集計に追加
          }
        }
        if (subMenuGroupTotalPrice > 0) { // サブメニューに0円以上のメニューがある場合
          var subMenuPrice = parseInt(menu.price)+subMenuGroupTotalPrice; // 親メニュー + サブメニューの合計金額
          formattedPrice = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(subMenuPrice)+"〜"; // 最安の合計金額〜を返す
        }
      }
    }
    return formattedPrice;
  }

  /**
   * ヘッダーメニューカテゴリーのカテゴリが選択された。
   */
  selectCategoryIndex(idx){
    let margin = 100;
    if (this.iTotal > 0) margin += 50;

    console.log(this.scrollBox.nativeElement.parentNode);
    let categoryBoxElement = document.getElementById(`category_${idx.id}`);
    console.log(categoryBoxElement);
    if (categoryBoxElement){
      this.scrollBox.nativeElement.parentNode.scrollTo(0, categoryBoxElement.offsetTop - margin);
    }
  }

  /**
   * 現在カートに入っているメニューの数量をアップデートする
   *
   * @param from これは何なんだろう
   */
  async updateCartItemNum(from = 0){
    this.iTotal = 0;
    for (var i = 0; i < this.orderList.length; i++) {
      if (this.orderList[i].menu_id !== this.chargeId) {
        this.iTotal += this.orderList[i].quantity;
      }
    }
    this.resetContainerTopMargin();
  }

  /**
   * コンテナのトップマージンの調整
   */
  resetContainerTopMargin(){
    this.containerTopMargin = (this.iTotal > 0)
    ? "100px"
    : "50px";
  }

  /**
   * カートに進むがタップされた
   */
  onGoCart(){
    this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
  }

  /**
   * メニューがタップされた。
   * @param menu
   */
  onTapMenu(menu){
    if (menu.menuLockImageUri == "") this.showOrder(menu);
  }

  /**
   * orderの閉じるがタップされた
   */
  onHideOrder(){
    this.hideOrder();
  }

  /**
   * オーダー画面を開く
   *
   * @param menu
   */
  showOrder(menu){
    this.currentItemId = menu.menuId;
  }

  hideOrder(){
    this.currentItemId = 0;
  }

}



// WEBPACK FOOTER //
// ./src/pages/menulist/menulist.ts